import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import EditableInfo from "../../EditableInfo";
import { useAppSelector } from "@builder/store/store";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { SmartTileNode } from "@common/build/types";
import { EditableProps } from "../../editableProps";

const EditFolderTile = ({ condition }: EditableProps) => {
    const cvMode = useAppSelector(state => state.builder.conditionalVariationMode);
    const selectedNode = useAppSelector(getSelectedNode) as SmartTileNode;

    if (condition && !condition(selectedNode, cvMode)) return null;

    return (
        <SidebarCollapse title="Setup">
            <EditableInfo header="folderTileInfo1" paragraphs={["folderTileInfo2", "folderTileInfo3", "folderTileInfo4", "folderTileInfo5"]} />
        </SidebarCollapse>
    );
};

export default EditFolderTile;
